<template>
  <div
    v-if="selectedTierPlan"
    class="subcription-section"
  >
    <div
      v-if="hasOnlyFreePlans"
      class="subcription-section_inner f-column"
    >
      <div class="chosen-plan mx-auto">
        <div class="chosen-plan_title">
          <div>
            {{ $t(`gametypes.groups.${gm_type}_long`) }} /
            {{ selectedTierPlan.full_name }}
          </div>
          <!-- {{ selectedTierPlan.name }} -->
          {{ numFixed(selectedTierPlan.month_price) }}
          <span class="month">
            <b>USD</b>
            /
            {{
              selectedTierPlan.affiliate && selectedTierPlan.yearlySavings
                ? $t('subscription.first_month')
                : $t('subscription.month')
            }}
          </span>
        </div>
        <div class="chosen-plan_subtitle">
          <span v-if="selectedTierPlan.subtitle">
            {{ selectedTierPlan.subtitle }}
            {{
              selectedTierPlan.affiliate && !selectedTierPlan.yearlySavings
                ? '/ ' + $t('subscription.first_year')
                : ''
            }}
          </span>
          <span v-else-if="selectedTierPlan.yearlySavings">
            {{
              $t('subscription.want_to_save_amount_year_tra01', {
                amount_num: numFixed(selectedTierPlan.yearlySavings),
              })
            }}
            <span
              class="switch-to-yearly"
              @click="switchToYearly"
            >
              {{ $t('subscription.switch_to_yearly') }}
            </span>
          </span>
        </div>
      </div>
      <PaymentGates
        class="mt-4"
        :onSuccessPayment="handleSuccess"
      />
    </div>

    <div
      v-else
      class="subcription-section_inner f-column"
    >
      <div class="mx-auto f-center f-column">
        <div
          class="w-100"
          style="padding: 1rem; background: rgba(0, 0, 0, 0.35); border-radius: 8px"
        >
          <UpdatePaymentPlan
            :hasEbMessage="false"
            :startAtStep="2"
          />
          <div class="d-flex w-100 mt-6">
            <portal-target name="update_payment_confirm_btn"></portal-target>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { nextTick } from 'vue'
import PaymentGates from '@/components/Payments/PaymentGates'
import UpdatePaymentPlan from '@/components/Dialogs/UpdatePaymentPlanDialog/UpdatePaymentPlan'
import format_mix from '@/mixins/format_mix'
import payment_mix from '@/mixins/payment_mix'
import tier_mix from '@/mixins/tier_mix'

export default {
  name: 'SubscriptionPaymentGate',
  components: {
    PaymentGates,
    UpdatePaymentPlan,
  },
  mixins: [payment_mix, format_mix, tier_mix],
  mounted() {
    nextTick(() => {
      this.segTrack()
    })
  },
  methods: {
    handleSuccess({ payment_provider, payment_method }) {
      const plan = this.selectedPlan

      this.$router.push({
        name: 'SubscriptionPaymentConfirmation',
        query: {
          payment_provider,
          payment_method,
          dialogs: '',
          gm_type: plan.type.toLowerCase(),
          gm_tier: plan.tier.toLowerCase(),
          gm_interval: plan.interval?.toLowerCase(),
        },
      })
    },
  },
  computed: {
    discord_tag() {
      const { mergedUserSettings } = this.$store.getters
      return mergedUserSettings?.discord_tag
    },
  },
}
</script>

<style lang="scss" scoped>
@media (max-width: 767px) {
  .chosen-plan {
    width: 100% !important;
  }
}
.gate-box {
  // background: var(--clr-black-3);
  border-radius: 4px;
  width: 100%;
  max-width: calc(100vw - 2rem);
}
.subcription-text {
  font-size: 0.8rem;
}
.terms {
  text-decoration: underline !important;
  color: var(--clr-white-0);
}
.switch-to-yearly {
  cursor: pointer;
  color: var(--clr-primary);
  &:hover {
    text-decoration: underline;
  }
}
.chosen-plan {
  position: relative;
  text-align: center;
  width: 34rem;
  font-size: 1.5rem;
  font-weight: 500;
  padding-bottom: 0.5rem;
  width: 80%;
  color: #d1d1d1;
  &_title {
    font-size: 2rem;
    font-weight: 700;
    color: var(--clr-white-0);
    .month {
      font-size: 1.5rem;
      font-weight: 500;
    }
  }
  &_subtitle {
    font-size: 1rem;
    padding: 0.05rem 0 0 0;
  }
}
</style>
